import { render, staticRenderFns } from "./filter-collection.vue?vue&type=template&id=38c93694"
import script from "./filter-collection.vue?vue&type=script&lang=ts"
export * from "./filter-collection.vue?vue&type=script&lang=ts"
import style0 from "./filter-collection.vue?vue&type=style&index=0&id=38c93694&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports